module.exports = __webpack_public_path__ + "img/computer.0fa868a6.png";